import { useMemo, useState } from "react";
import { Badge } from "flowbite-react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

const HistoricoConsultas = ({
  historicoConsultas = [],
  quantidadeTotal,
  periodoInicial,
  periodoFinal,
  quantidadeTotalMes,
  hasQtdMes = false,
}) => {
  const [expandido, setExpandido] = useState(false);

  const LIMITE = 5;
  const total = historicoConsultas.length;
  const restantes = Math.max(total - LIMITE, 0);

  const listaExibida = useMemo(
    () =>
      expandido ? historicoConsultas : historicoConsultas.slice(0, LIMITE),
    [expandido, historicoConsultas],
  );

  return (
    <>
      {Number.isFinite(quantidadeTotal) || (
        <div className="flex flex-wrap gap-3 mb-4 mt-4">
          {Number.isFinite(quantidadeTotal) && (
            <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 px-3 py-1.5 rounded-full text-sm font-medium">
              <span>Quantidade Total:</span>
              <span>{quantidadeTotal}</span>
            </div>
          )}

          {hasQtdMes && (
            <div className="flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 px-3 py-1.5 rounded-full text-sm font-medium">
              <span>Quant. de consultas no mês atual:</span>
              <span>{quantidadeTotalMes}</span>
            </div>
          )}

          {periodoInicial && periodoFinal && (
            <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-700 px-3 py-1.5 rounded-full text-sm font-medium">
              <span>Período:</span>
              <span>
                {periodoInicial} até {periodoFinal}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Tabela + Fade quando colapsado */}
      <div className="relative rounded-2xl border border-gray-200 overflow-hidden mt-2">
        <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
          <div className="grid grid-cols-2 gap-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">
            <div>Data</div>
            <div>Empresa</div>
          </div>
        </div>

        {/* Área com transição de altura */}
        <div
          className={`transition-all duration-300 ease-out ${
            expandido ? "max-h-[9999px]" : "max-h-auto"
          } overflow-hidden`}
        >
          {listaExibida.map((consulta, index) => (
            <div
              key={index}
              className={`grid grid-cols-2 gap-4 px-4 py-3 text-sm items-center ${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              }`}
            >
              <div className="text-gray-700">{consulta?.data || "-"}</div>
              <div className="font-medium text-gray-900">
                {consulta?.empresa?.toUpperCase().includes("ENJOY") ||
                consulta?.empresa?.toUpperCase().includes("IMPACTO")
                  ? "GRANDES BANCOS"
                  : consulta?.empresa || "-"}
              </div>
            </div>
          ))}
        </div>

        {/* Fade indicando que há mais quando colapsado */}
        {!expandido && total > LIMITE && (
          <div className="pointer-events-none absolute inset-x-0 bottom-[52px] h-16 bg-gradient-to-t from-white to-white/0" />
        )}

        {/* Footer com contador + botão */}
        {total > LIMITE && (
          <div className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-t border-gray-200">
            <button
              type="button"
              onClick={() => setExpandido((v) => !v)}
              aria-expanded={expandido}
              className="inline-flex items-center gap-2 rounded-xl border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {expandido ? (
                <>
                  <HiChevronUp className="text-lg" />
                  Ver menos
                </>
              ) : (
                <>
                  <HiChevronDown className="text-lg" />
                  Ver mais
                </>
              )}
            </button>
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <Badge color="gray">
                Exibindo {Math.min(LIMITE, total)} de {total}
              </Badge>
              {!expandido && restantes > 0 && (
                <span className="text-gray-500">(+{restantes} restantes)</span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Aviso quando colapsado */}
      {!expandido && total > LIMITE && (
        <div className="text-sm mt-3 text-gray-500 text-center">
          Exibindo as últimas {LIMITE} ocorrências.
        </div>
      )}
    </>
  );
};

export default HistoricoConsultas;
